<script>
import { mapActions } from 'vuex'
import OffersPreview from './components/offers-preview'

export default {
  name: 'RetailerOffersPreview',
  page: {
    title: 'Retailer Offers Preview',
  },
  components: {
    OffersPreview,
  },
  data() {
    return {
      retailer: {},
      offers: [],
      loading: false,
    }
  },
  computed: {
    id() {
      return this.$route.params.id
    },
  },
  async created() {
    await this.fetchRetailer()
    await this.fetchRetailerOffers()
  },
  methods: {
    ...mapActions('retailer', ['getRetailer']),
    ...mapActions('offer', ['getRetailerOffers']),
    async fetchRetailer() {
      this.loading = true
      const [err, response] = await this.getRetailer(this.id)

      if (err) {
        this.$router.replace({
          name: 'retailer-offers',
          params: { id: this.id },
        })
      } else {
        this.retailer = response
      }

      this.loading = false
    },
    async fetchRetailerOffers() {
      this.loading = true
      const [, response] = await this.getRetailerOffers(this.id)

      if (response && response.items) {
        this.offers = response.items.sort((a, b) => {
          return a.sortIndex !== b.sortIndex
            ? a.sortIndex - b.sortIndex
            : new Date(b.createdAt).getTime() - new Date(a.createdAt).getTime()
        })
      }

      this.loading = false
    },
    closePreview() {
      this.$router.push({
        name: 'retailer-offers',
      })
    },
  },
}
</script>

<template>
  <main-layout
    :header="false"
    :loading="loading"
  >
    <div :class="$style.offersPreview">
      <div :class="$style.header">
        <div :class="[$style.container, $style.headerContent]">
          <b>Preview mode</b>
          <el-button
            type="text"
            @click="closePreview"
          >
            <div :class="$style.button">
              Close preview
              <i class="el-icon-close" />
            </div>
          </el-button>
        </div>
      </div>

      <div :class="[$style.container, $style.content]">
        <offers-preview
          :retailer="retailer"
          :offers="offers"
        />
      </div>
    </div>
  </main-layout>
</template>

<style lang="scss" module>
  .offersPreview {
    margin: -2rem;
  }

  .container {
    max-width: rem(800px);
    margin: 0 auto;
  }

  .header {
    width: 100%;
    padding: rem(20px);
    background: #202D3C;
  }

  .headerContent {
    position: relative;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: rem(18px);
    color: var(--color-primary-text);
    text-align: center;
  }

  .content {
    padding-top: rem(40px);
    padding-bottom: rem(40px);
  }

  .button {
    position: absolute;
    top: 50%;
    right: 0;
    display: flex;
    align-items: center;
    color: var(--color-primary-text);
    transform: translateY(-50%);

    :global {
      .el-icon-close {
        margin-left: rem(8px);
        font-size: rem(20px);
      }
    }
  }
</style>
